/**
 * Integración de reserva directa con operadores externos (Homiii).
 * Desactivado por defecto hasta aprobación comercial/técnica del partner.
 *
 * Activar: VUE_APP_BOOKING_INTEGRATION_ENABLED=true en .env.local / .env.production
 */
export const BOOKING_INTEGRATION_ENABLED =
  process.env.VUE_APP_BOOKING_INTEGRATION_ENABLED === 'true';

export const BOOKING_INTEGRATION_PROVIDERS = ['homiii'];

/** ¿Este listing tiene reserva directa activa? */
export function hasDirectBooking(contract) {
  return BOOKING_INTEGRATION_ENABLED && !!contract?.bookingIntegration;
}
